// Signature Maker Tool — draw or type a signature, download as a transparent PNG.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const signatureMakerTool: Tool = {
  id: "signature-maker",
  name: () => m.sig_tool_name(),
  description: () => m.sig_tool_description(),
  icon: "✍️",
  basePath: "/signature-maker",
  status: "stable",
  tags: ["signature", "sign", "document", "esign", "pdf"],
  pages: [
    {
      name: () => m.sig_nav_main(),
      path: "/signature-maker",
      description: () => m.sig_nav_main_desc(),
      icon: "✍️",
    },
    {
      name: () => m.sig_nav_type(),
      path: "/signature-maker/type",
      description: () => m.sig_nav_type_desc(),
      icon: "⌨️",
    },
  ],
};
